// Clinic Configuration for Todays Dental Cayce
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Todays Dental @ Cayce",
  clinicId: "todaysdentalcayce",
  clinicUrl: "https://todaysdentalcayce.com",
  // Contact Information
  phoneNumber: "803-233-6141",
  phoneNumberRaw: "+18032336141", // For tel: and sms: links
  email: "Dentist@TodaysDentalCayce.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=todaysdentalcayce&agentId=c3c70488-4961-494e-b49f-6d32ffeab25b",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/todaysdentalcayce/voice",

  // Location
  address: "1305 Knox Abbott Dr suite 101, Cayce, SC 29033, USA",
  addressShort: "1305 Knox Abbott Dr suite 101, Cayce, SC 29033",
  city: "Cayce",
  hcity: "Cayce",
  state: "South Carolina",
  stateShortForm: "SC",
  PostalCode: "29033",
  // Map Links
  mapUrl: "https://maps.app.goo.gl/eU4TuxoySfuqfwib7",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d25434.71807451479!2d-81.073266!3d33.977602000000005!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f8bb615c2cf933%3A0xdedf7090f910fc78!2sTodays%20Dental%20%40%20Cayce!5e1!3m2!1sen!2sin!4v1756790859282!5m2!1sen!2sin',
  iframeTitle: "Todays Dental @ Cayce",

  //membership
  membership: "https://member.kleer.com/?slug=AW9Y",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/TodaysDentalatCayce",

  // Cherry
  cherryUrl: "https://todaysdentalcayce.com/patient-portal",

  // Analytics
  clarityProjectId: "pqbgmaxpjv",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/todaysdentalcayce",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/todaysdentalcayce",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/todaysdentalcayce",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://todaysdentalcayce.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/todaysdentalcayce",
    instagram: "https://www.instagram.com/todaysdentalcayce/",
    twitter: "https://x.com/td_cayce",
    linkedin: "https://www.linkedin.com/company/todays-dental-cayce/",
    youtube: "https://www.youtube.com/@todaysdentalcayce/videos",
  },

  // Open Dental Configuration
  defaultProvNum: 1,
  defaultOpNum: 28,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: 'New patient emergency/other',
      label: 'New patient emergency/other',
      duration: 30,
      opNum: 29,
      AppointmentTypeNum: 11
    },
    {
      value: 'Existing patient emergency/other',
      label: 'Existing patient emergency/other',
      duration: 30,
      opNum: 28,
      AppointmentTypeNum: 21
    },
    {
      value: 'Existing patient current treatment Plan',
      label: 'Existing patient current treatment Plan',
      duration: 30,
      opNum: 28,
      AppointmentTypeNum: 44
    }
  ],


  // Twilio Configuration
  twilioPhoneNumber: "18039218950",

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:+${this.twilioPhoneNumber}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;  
